window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};


repos.playerTransactionsRepo = function () {

    var url = 'api/playertransactions';


    var list = function (datumOd, datumDo, tip, page) {
        return fetch(url +
                casino.repos.base.serializeGetParams({
                    datumOd: datumOd,
                    datumDo: datumDo,
                    vrsta: tip,
                    page: page
                }), {
                    credentials: repos.base.credentials,
                    headers: repos.base.headers()
                })
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);
    };

    return {
        list: list
    }

}();